import React, { useState } from 'react'
import useForm from '@/hooks/useForm'
import { errorToast } from '@/utils/toasters'
import { Validations } from '@/utils/validations'
import { useUpdate } from '@/api/hooks'
import { UpdateProviderProfile, uploadFile } from '@/api/endpoints'

const useEditProfile = (providerInfo) => {
    const { formHandler } = useForm()
    const [isLoading, setIsLoading] = useState(false)
    const { onUpdate, isPending: isUpdating } = useUpdate(UpdateProviderProfile)

    const { formValues } = formHandler

    const handleSave = () => {

        let required = Object.values(formValues).filter((item) => item?.isRequired && (Validations.isNull(item?.value) || Validations.isUndefined(item?.value) || item?.value == ''))
        if (required.length > 0) {
            errorToast("required-fields")
            return
        }
        setIsLoading(true)

        const formData = new FormData()
        let oldIDs = []
        if (formValues?.technologies?.some(technology => technology?.picture) || formValues?.accredetationsImgs
            || formValues?.GalleryImgs?.value || formValues?.logo?.value?.length || formValues?.providerDocs?.some(technology => technology?.picture)) {
            if (formValues?.technologies?.some(technology => technology?.picture)) {

                formValues?.technologies?.forEach(technology => {
                    technology?.picture?.forEach((picture) => {
                        technology?.picture && oldIDs.push(technology?.attachmentId)
                        formData.append(`technologies/${technology.name}`, picture)
                    })
                })
            }
            if (formValues?.logo?.value?.length) {

                formValues?.logo?.value?.forEach(logo => {
                    formData.append(`logo`, logo)
                })
            }
            if (formValues?.providerDocs?.some(technology => technology?.picture)) {

                formValues?.providerDocs?.filter(technology => technology?.picture).forEach?.(technology => {
                    formData.append(`${technology.name}`, technology?.picture)
                })
            }
            if (formValues?.accredetationsImgs) {

                (formValues?.accredetationsImgs || [])?.forEach(technology => {
                    formData.append(`accredetationsImgs/${technology.name}`, technology.value[0])
                })
            }
            if (formValues?.GalleryImgs) {

                (formValues?.GalleryImgs)?.value?.forEach(technology => {
                    formData.append(`GalleryImgs`, technology)
                })
            }
            uploadFile(formData).then(response => {
                submitRequest(response?.data)
            }).catch(error => {
                console.log(error)
            })
        }
        else {

            submitRequest()
        }
    }


    const submitRequest = (ids = []) => {
        const data = formValues

        const dataObject = {

            email: data?.email?.value,
            providerName: data?.providerName?.value,
            providerNameEN: data?.providerNameEN?.value,

            profileSummary: data?.profileSummary,
            profileSummaryEN: data?.profileSummaryEN,

            description: data?.description,
            descriptionEN: data?.descriptionEN,

            phoneNumber: data?.phoneNumber?.value,
            websiteUrl: data?.websiteUrl?.value,
            mainAddress: data?.mainAddress?.value,
            mainAddressEN: data?.mainAddressEN?.value,

            refundPolicy: data?.refundPolicy,
            refundPolicyEN: data?.refundPolicyEN,
            refundPercentage: data?.refundPolicyAmount?.value,

            paymentTerms: data?.paymentTerms,
            paymentTermsEN: data?.paymentTermsEN,
            partialPaymentPercentage: data?.paymentTermsAmount?.value,

            videoUrl: data?.videoUrl?.value,
            DeletedFiles: data.deletedIds,
            sla: Number(data?.SLA?.value),
            accredationIds: data?.accredationIds?.value?.mapToIdsList(),
            serviceCategoryIds: data?.serviceCategoryIds?.value?.mapToIdsList(),
            govIds: data?.government?.value?.mapToIdsList(),
            areaIds: data?.area?.value?.mapToIdsList(),

            technologies: data?.technologies?.map((technology, index) => (
                {
                    name: technology.name,
                    nameEN: technology.nameEN,
                    description: technology.description,
                    descriptionEN: technology.descriptionEN,
                    attachmentId: ids[index] || providerInfo?.technologies[index]?.attachmentId
                })) || [],
            escalations: data?.scalations?.map((scalation, index) => (
                {
                    name: scalation.name,
                    level: scalation.level,
                    email: scalation.email,
                    phoneNumber: scalation.phoneNumber,
                    escalateAfterHours: scalation.escalateAfterHours,
                    notifyByEmail: !!scalation.sendVia?.find(item => item.value == 1) || scalation.notifyByEmail,
                    notifyBySMS: !!scalation.sendVia?.find(item => item.value == 2) || scalation.notifyBySMS,
                    IsNotificationEnabled: scalation.disabled?.value == 1,
                })) || [],
            attachmentsIds: [],
            files: ids,
            location: data?.googleMapLink,
            deletedFiles: data?.deletedFiles || []

        }

        onUpdate(providerInfo?.id, dataObject, () => {
            window.location.reload()

        })
        setIsLoading(false)
    }



    return {
        handleSave,
        submitRequest,
        isLoading,
        formHandler,
        isUpdating
    }
}

export default useEditProfile